import { AutocompleteField } from "@models/autocompleteField";
import { DataFields } from "@utils/DataField";

export class SearchDataFields extends DataFields {

    jobs: AutocompleteField[]
    locations: AutocompleteField[]
    contractTypes: AutocompleteField[]

    errorMessage = "Oups, le formulaire est incomplet.";

    _errorDataFieldMap = new Map<string, string>([
        ["jobs", "Merci de compléter votre poste recherché."],
        ["locations", "Merci de compléter votre localisation de poste recherché."],
        ["contractTypes", "Merci de compléter votre type de contrat recherché."]
    ]);

    toJson() {
        return {
            "jobs" : this.jobs,
            "locations": this.locations,
            "contractTypes": this.contractTypes
        }
    }
    toArray() {
        return [
            this._toValidity("jobs", this.jobs.length > 0),
            this._toValidity("locations", this.locations.length > 0),
            this._toValidity("contractTypes", this.contractTypes.length > 0)
        ]
    }
}